var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBellsoft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#FFF5F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.225 63.037C29.3611 64.2006 31.1629 65.3204 32.6121 65.3083L67.6234 65.0145C68.6969 65.0054 70.373 65.0968 69.9258 64.1208C69.7997 63.8458 69.5831 63.4917 69.2418 63.037C67.3736 60.5484 64.3987 58.5496 64.3987 58.5496L64.0538 42.3579C64.0538 42.3579 63.7607 36.9483 60.0055 34.3799C57.1232 32.4086 54.8892 31.5276 54.0064 31.2245C53.7648 31.1416 53.5956 30.9165 53.5956 30.6611C53.5956 29.2718 53.4146 27.7789 52.3399 26.8984C51.7682 26.4302 50.9769 26.0368 49.9175 26.0025C49.0505 25.9744 48.3439 26.1884 47.7832 26.4935C46.3492 27.2738 46.0489 29.0719 46.0489 30.7044C46.0489 30.9363 45.9011 31.141 45.6821 31.2174C44.5208 31.6223 40.8827 33.0014 38.8747 35.0255C36.463 37.4564 35.258 39.9554 35.258 42.3579C35.258 44.7604 35.258 58.5496 35.258 58.5496C35.258 58.5496 30.8611 62.1802 30.225 63.037Z",
    stroke: "#D91F05",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5157 72.048C54.5157 73.3641 52.4409 74.431 49.8816 74.431C47.3222 74.431 45.2474 73.3641 45.2474 72.048C45.2474 70.7319 47.3222 69.665 49.8816 69.665C52.4409 69.665 54.5157 70.7319 54.5157 72.048Z",
    stroke: "#D91F05",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellsoft);
export default __webpack_public_path__ + "static/media/bellsoft.5a4a79eb10fbdcf3a46ed42a6379dc1d.svg";
export { ForwardRef as ReactComponent };